<div id="demographics" class="registration container">
  <form #demographicsForm="ngForm" [ngClass]="{'form-complete': demographicsForm.valid }" (ngSubmit)="forward(demographicsForm)" novalidate autocomplete="off" appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.DEMOGRAPHICS.heading' | copy | async }}</h1>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.subheading' | copy | async }}
        </div>
      </div>

      <article>
        <div class="card-body w-100">

          <!--First Time Quesiton-->
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value === 'Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
            <label class="w-100 " for="firstTime" aria-labelledby="firstTime">{{'copy.label.DEMOGRAPHICS.firsttimedemo'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="varFirstTime.Value" name="firstTimeValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value === 'Non-Benefit Advisor' || attendee.PAXTypeNo === 27) && attendee.PAXTypeNo !== 50 && varFirstTime.Value === 'No'">
            <mat-form-field class="w-100">
              <label>{{'copy.label.DEMOGRAPHICS.pastattendee' | copy | async}}</label>
              <mat-select disableRipple name="pastattendance" id="pastattendance" #pastattendance="ngModel" [(ngModel)]="varPastEventsAttend.Value" required>
                <mat-option *ngFor="let ss of timesattending" value="{{ss}}">{{ss}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          
          <div *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Sponsor' || varTrack.Value === 'Home Office' || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24">
            <label class="w-100" for="varveteran">{{'copy.label.ATTENDEE.veteran' | copy | async }}</label>
            <mat-form-field class="w-40">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="varveteran" id="varveteran" #varveteran="ngModel" [(ngModel)]="varVeteran.Value" required>
                <mat-option *ngFor="let ss of veteranlist" value="{{ss}}">{{ss}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100" *ngIf="varVeteran.Value === 'Yes - Other'">
              <mat-label for="veteranother" aria-labelledby="veteranother" [ngClass]="{'active' : varVeteranOther.Value}">{{ 'copy.label.ATTENDEE.veteranother' | copy | async }}</mat-label>
              <input matInput name="veteranother" id="veteranother" [attr.aria-label]="veteranother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varVeteranOther.Value" #veteranother="ngModel" required/>
              <mat-error><app-validation  [object]="veteranother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Sponsor' || varTrack.Value === 'Home Office' || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24">
            <label class="w-100" for="varfirstresponder">{{'copy.label.ATTENDEE.firstresponder' | copy | async }}</label>
            <mat-form-field class="w-40">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="varfirstresponder" id="varfirstresponder" #varfirstresponder="ngModel" [(ngModel)]="varFirstresponder.Value" required>
                <mat-option *ngFor="let ss of firstresponderlist" value="{{ss.value}}">{{ss.display}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100" *ngIf="varFirstresponder.Value === 'Yes - Other'">
              <mat-label for="firstresponder" aria-labelledby="firstresponder" [ngClass]="{'active' : varFirstresponderOther.Value}">{{ 'copy.label.ATTENDEE.firstresponderother' | copy | async }}</mat-label>
              <input matInput name="firstresponder" id="firstresponder" [attr.aria-label]="firstresponder" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varFirstresponderOther.Value" #firstresponder="ngModel" required/>
              <mat-error><app-validation  [object]="firstresponder" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50" class="w-100">
            <div class="w-100 required">
              <label class="w-100" for="stock" aria-labelledby="stock">{{'copy.label.ATTENDEE.lplastock'|copy|async}}</label>
              <mat-radio-group class="w-100" [(ngModel)]="varLPLAStockholder.Value" name="stock" required>
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
            </div>
            <div *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
              <label class="w-100" for="firstTime">{{'copy.label.ATTENDEE.contributelplpac' | copy | async }}</label>
              <mat-form-field class="w-40">
                <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
                <mat-select disableRipple name="contribute" id="contribute" #contribute="ngModel" [(ngModel)]="varContribute.Value" required>
                  <mat-option *ngFor="let response of contributeResponses" value="{{response.value}}">{{response.display}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="varContribute.Value === 'Yes'">
                <div class="w-100" [innerHTML]='"copy.html.LPLPAC1" | copy | async'></div>

                <mat-form-field class="w-100 twoLineSelect">
                  <mat-label>{{ 'copy.label.ATTENDEE.contribution' | copy | async }}</mat-label>
                  <mat-select name="contributiondropdown" id="contributiondropdown" #contributiondropdown="ngModel" [(ngModel)]="this.enrollment.$mtccontributetemp" required>
                    <mat-option *ngFor="let x of contributiondropdownlist" value="{{x}}">{{x}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-100 longQuestionText" *ngIf="this.enrollment.$mtccontributetemp === 'Other'">
                  <mat-label for="contribution" aria-labelledby="contribution" [ngClass]="{'active' : contribution}">{{ 'copy.label.ATTENDEE.otheramount' | copy | async }}</mat-label>
                  <input matInput name="contribution" id="contribution" [attr.aria-label]="contribution" type="number" min="250" maxlength="100" pattern="^(0|[0-9][0-9]*)$"[(ngModel)]="varContribution.Value" #contribution="ngModel" required/>
                  <mat-error *ngIf="contribution.hasError('min')">
                    {{'copy.label.ATTENDEE.contributionminerror'|copy|async}}
                  </mat-error>
                  <mat-error><app-validation  [object]="contribution" isRequired=true pattern="alphanum"></app-validation></mat-error>
                </mat-form-field>

                <label class="w-100" for="initials"><i>{{'copy.label.ATTENDEE.contributionnote' | copy | async }}</i></label>
                <mat-form-field class="w-100">
                  <mat-label for="initials" aria-labelledby="initials" [ngClass]="{'active' : initials}">{{ 'copy.label.ATTENDEE.initials' | copy | async }}</mat-label>
                  <input matInput name="initials" id="initials" [attr.aria-label]="initials" type="text" maxlength="10" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="varInitials.Value" #initials="ngModel" required/>
                  <mat-error><app-validation  [object]="initials" isRequired=true pattern="alpha"></app-validation></mat-error>
                </mat-form-field>
                <div class="w-100" [innerHTML]='"copy.html.LPLPAC2" | copy | async'></div>
              </div>
            </div>
          </div>
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
            <label class="w-100" for="stateNetwork" aria-labelledby="stateNetwork">
              <span [innerHTML]="'copy.html.stateNetwork'|copy|async"></span>
              <a class="ml-1" matTooltip="{{'copy.label.ATTENDEE.stateNetworkToolTip'|copy|async}}">
                <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
              </a>
            </label>
            <mat-radio-group class="w-100" [(ngModel)]="stateNetwork.Value" name="stateNetworkValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>
          
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value==='Home Office' || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 49 || 
            attendee.PAXTypeNo === 22 || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24) && attendee.PAXTypeNo !== 50">
            <label class="w-100" for="adaSeating" aria-labelledby="adaSeating">
              <span [innerHTML]="'copy.label.DEMOGRAPHICS.adaSeatingLabel'|copy|async"></span>
            </label>
            <mat-radio-group class="w-100" [(ngModel)]="varAdaSeating.Value" name="adaSeatingValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>  
          </div>

          <!--Sponsor Pre Conference Question-->
          <div class="w-100 required" *ngIf="attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 28">
            <label class="w-100" [innerHTML]='"copy.html.demosponsorpreconf" | copy | async'></label>
            <!--a matTooltip="{{'copy.label.DEMOGRAPHICS.preconftooltip'|copy|async}}">
              <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
            </a-->
            <mat-radio-group class="w-100" [(ngModel)]="varSponsorPreConference.Value" name="sponsorpreconfValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field class="w-100"  *ngIf="attendee.PAXTypeNo === 28">
            <mat-label for="supplierrole" aria-labelledby="supplierrole" [ngClass]="{'active' : varSupplierRole.Value}">{{ 'copy.label.DEMOGRAPHICS.supplierrole' | copy | async }}</mat-label>
            <input matInput name="supplierrole" id="supplierrole" [attr.aria-label]="supplierrole" type="text" class="form-control" maxlength="50" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varSupplierRole.Value" #supplierrole="ngModel" required />
            <mat-error><app-validation  [object]="supplierrole" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>
          <p class="w-100"  *ngIf="attendee.PAXTypeNo === 28" [innerHTML]='"copy.html.supplierrolenote" | copy | async'></p>

          <!--Preconf Designated Speaker Question-->
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Home Office' && attendee.PAXTypeNo !== 29)  || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 22">
            <label class="w-100 " for="desigspeakerValue" aria-labelledby="desigspeakerValue">{{'copy.label.DEMOGRAPHICS.designatedspeaker'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="varDesignatedSpeaker.Value" name="desigspeakerValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <!--Welcome Reception Question-->
          <!-- <div class="w-100 required" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Home Office' || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 22 || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24">
            <label [innerHTML]='"copy.html.demowelcomereception" | copy | async'></label>
            <a class="ml-1" matTooltip="{{'copy.label.DEMOGRAPHICS.welcomereceptiontooltip'|copy|async}}">
              <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
            </a>
            <mat-radio-group class="w-100" [(ngModel)]="varWelcomeReception.Value" name="welcomereceptionValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div> -->

          <!--Final Night Question-->
          <!-- <div class="w-100 required" *ngIf="varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Home Office' || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 22 || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24">
            <label [innerHTML]='"copy.html.democoncert" | copy | async'></label>
            <a class="ml-1" matTooltip="{{'copy.label.DEMOGRAPHICS.concerttooltip'|copy|async}}">
              <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
            </a>
            <mat-radio-group class="w-100" [(ngModel)]="varFinalNightConcert.Value" name="concertValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div> -->

        
          <!--Donation Questions-->
          <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value === 'Home Office' || attendee.PAXTypeNo === 27) && attendee.PAXTypeNo !== 50 && !isRegComplete">
            <!-- <label class="w-100 " for="firstTime" aria-labelledby="firstTime">{{'copy.label.DEMOGRAPHICS.firsttime'|copy|async}}</label> -->
            <div class="w-100" [innerHTML]='"copy.html.demodonation" | copy | async'></div>
            <label class="w-100">{{'copy.label.DEMOGRAPHICS.foundationquestion'|copy|async}}</label>
            <mat-radio-group class="w-100" [(ngModel)]="varDonation.Value" name="donationValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <mat-form-field class="w-100" *ngIf="varDonation.Value === 'Yes' && !isRegComplete">
            <label>{{'copy.label.DEMOGRAPHICS.donationamount' | copy | async}}</label>
            <mat-select disableRipple name="donationamount" id="donationamount" #donationamount="ngModel" [(ngModel)]="varDonationAmount.Value" required>
              <mat-option *ngFor="let ss of donationvalues" value="{{ss}}">{{ss}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-100" *ngIf="varDonationAmount.Value === 'Other' && varDonation.Value === 'Yes' && !isRegComplete">
            <label for="donateother" aria-labelledby="donateother" [ngClass]="{'active' : donateother}">{{ 'copy.label.DEMOGRAPHICS.donationother' | copy | async }}</label>
            <input matInput name="donateother" id="donateother" [attr.aria-label]="donateother" type="number" class="form-control" maxlength="100" pattern="^(0|[0-9][0-9]*)$" [(ngModel)]="varDonationOther.Value" #donateother="ngModel" required/>
            <mat-error><app-validation  [object]="donateother" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>

          <!-- <div *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor'" class="w-100">
            <label class="w-100" for="varAffiliationid">{{'copy.label.DEMOGRAPHICS.affiliation' | copy | async }}</label><br/>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="varAffiliationid" id="varAffiliationid" #varAffiliationid="ngModel" [(ngModel)]="varAffiliation.Value" required>
                <mat-option *ngFor="let ss of affiliationlist" [value]="ss.value">{{ss.display}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100" *ngIf="varAffiliation.Value === 'Other'">
              <mat-label for="afilother" aria-labelledby="afilother" [ngClass]="{'active' : varAffiliationOther.Value}">{{ 'copy.label.DEMOGRAPHICS.affilotherlabel' | copy | async }}</mat-label>
              <input matInput name="afilother" id="afilother" [attr.aria-label]="afilother" type="text" class="form-control" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varAffiliationOther.Value" #afilother="ngModel" required/>
              <app-validation  [object]="afilother" isRequired=true pattern="alphanum"></app-validation>
            </mat-form-field>
          </div> -->

          <!--Prayer Question-->
          <div class="w-100 required" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value==='Home Office'">
            <label class="label-display">
              <span [innerHTML]='"copy.html.demobreakfast" | copy | async'></span>
              <a class="ml-1" matTooltip="{{'copy.label.DEMOGRAPHICS.demobreakfasttooltip'|copy|async}}">
                <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
              </a>
            </label>
            
            <mat-radio-group class="w-100" [(ngModel)]="varBreakfast.Value" name="breakfastValue" required>
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="w-100 required" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor'">
            <label class="label-display">
              <span [innerHTML]="'copy.label.DEMOGRAPHICS.careerStage'|copy|async"></span>
            </label>
            <mat-radio-group class="w-100" [(ngModel)]="varCareerStage.Value" name="careerStageValue" required>
              <mat-radio-button *ngFor="let stage of careerStageList" value="{{stage}}">{{stage}}</mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
            <p>{{'copy.label.DEMOGRAPHICS.topicsNote' | copy | async }}</p>
            <label class="w-100" for="vartopicone">{{'copy.label.DEMOGRAPHICS.topicOne' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vartopicone" id="vartopicone" #vartopicone="ngModel" [(ngModel)]="varTopicOne.Value" (ngModelChange)="topicOneChanged()" required>
                <mat-option *ngFor="let topic of topicListOne" value="{{topic}}">{{topic}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100" *ngIf="varTopicOne.Value === 'Other'">
              <mat-label for="vartopiconeother" aria-labelledby="vartopiconeother" [ngClass]="{'active' : varTopicOneOther.Value}">{{ 'copy.label.DEMOGRAPHICS.topicOneOther' | copy | async }}</mat-label>
              <input matInput name="vartopiconeother" id="vartopiconeother" [attr.aria-label]="vartopiconeother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varTopicOneOther.Value" #vartopiconeother="ngModel" required/>
              <mat-error><app-validation  [object]="vartopiconeother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>

            <label class="w-100" for="vartopiconelevel">{{'copy.label.DEMOGRAPHICS.topicOneLevel' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vartopiconelevel" id="vartopiconelevel" #vartopiconelevel="ngModel" [(ngModel)]="varTopicOneLevel.Value" required>
                <mat-option *ngFor="let level of levelOfInfoList" value="{{level}}">{{level}}</mat-option>
              </mat-select>
            </mat-form-field>

            <label class="w-100" for="vartopictwo">{{'copy.label.DEMOGRAPHICS.topicTwo' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vartopictwo" id="vartopictwo" #vartopictwo="ngModel" [(ngModel)]="varTopicTwo.Value" (ngModelChange)="topicTwoChanged()" required>
                <mat-option *ngFor="let topic of topicListTwo" value="{{topic}}">{{topic}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100" *ngIf="varTopicTwo.Value === 'Other'">
              <mat-label for="vartopictwoother" aria-labelledby="vartopictwoother" [ngClass]="{'active' : varTopicTwoOther.Value}">{{ 'copy.label.DEMOGRAPHICS.topicTwoOther' | copy | async }}</mat-label>
              <input matInput name="vartopictwoother" id="vartopictwoother" [attr.aria-label]="vartopictwoother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varTopicTwoOther.Value" #vartopictwoother="ngModel" required/>
              <mat-error><app-validation  [object]="vartopictwoother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>

            <label class="w-100" for="vartopictwolevel">{{'copy.label.DEMOGRAPHICS.topicTwoLevel' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vartopictwolevel" id="vartopictwolevel" #vartopictwolevel="ngModel" [(ngModel)]="varTopicTwoLevel.Value" required>
                <mat-option *ngFor="let level of levelOfInfoList" value="{{level}}">{{level}}</mat-option>
              </mat-select>
            </mat-form-field>

            <label class="w-100" for="vartopicthree">{{'copy.label.DEMOGRAPHICS.topicThree' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vartopicthree" id="vartopicthree" #vartopicthree="ngModel" [(ngModel)]="varTopicThree.Value" (ngModelChange)="topicThreeChanged()" required>
                <mat-option *ngFor="let topic of topicListThree" value="{{topic}}">{{topic}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100" *ngIf="varTopicThree.Value === 'Other'">
              <mat-label for="vartopicthreeother" aria-labelledby="vartopicthreeother" [ngClass]="{'active' : varTopicThreeOther.Value}">{{ 'copy.label.DEMOGRAPHICS.topicThreeOther' | copy | async }}</mat-label>
              <input matInput name="vartopicthreeother" id="vartopicthreeother" [attr.aria-label]="vartopicthreeother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varTopicThreeOther.Value" #vartopicthreeother="ngModel" required/>
              <mat-error><app-validation  [object]="vartopicthreeother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>

            <label class="w-100" for="vartopicthreelevel">{{'copy.label.DEMOGRAPHICS.topicThreeLevel' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vartopicthreelevel" id="vartopicthreelevel" #vartopicthreelevel="ngModel" [(ngModel)]="varTopicThreeLevel.Value" required>
                <mat-option *ngFor="let level of levelOfInfoList" value="{{level}}">{{level}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
            <p>{{'copy.label.DEMOGRAPHICS.goalsNote' | copy | async }}</p>
            <label class="w-100" for="vargoalone">{{'copy.label.DEMOGRAPHICS.goalOne' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vargoalone" id="vargoalone" #vargoalone="ngModel" [(ngModel)]="varGoalOne.Value" (ngModelChange)="goalOneChanged()" required>
                <mat-option *ngFor="let goal of goalListOne" value="{{goal}}">{{goal}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100" *ngIf="varGoalOne.Value === 'Other'">
              <mat-label for="vargoaloneother" aria-labelledby="vargoaloneother" [ngClass]="{'active' : varGoalOneOther.Value}">{{ 'copy.label.DEMOGRAPHICS.goalOneOther' | copy | async }}</mat-label>
              <input matInput name="vargoaloneother" id="vargoaloneother" [attr.aria-label]="vargoaloneother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varGoalOneOther.Value" #vargoaloneother="ngModel" required/>
              <mat-error><app-validation  [object]="vargoaloneother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>

            <label class="w-100" for="vargoaltwo">{{'copy.label.DEMOGRAPHICS.goalTwo' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vargoaltwo" id="vargoaltwo" #vargoaltwo="ngModel" [(ngModel)]="varGoalTwo.Value" (ngModelChange)="goalTwoChanged()" required>
                <mat-option *ngFor="let goal of goalListTwo" value="{{goal}}">{{goal}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100" *ngIf="varGoalTwo.Value === 'Other'">
              <mat-label for="vargoaltwoother" aria-labelledby="vargoaltwoother" [ngClass]="{'active' : varGoalTwoOther.Value}">{{ 'copy.label.DEMOGRAPHICS.goalTwoOther' | copy | async }}</mat-label>
              <input matInput name="vargoaltwoother" id="vargoaltwoother" [attr.aria-label]="vargoaltwoother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varGoalTwoOther.Value" #vargoaltwoother="ngModel" required/>
              <mat-error><app-validation  [object]="vargoaltwoother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>

            <label class="w-100" for="vargoalthree">{{'copy.label.DEMOGRAPHICS.goalThree' | copy | async }}</label>
            <mat-form-field class="w-100">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="vargoalthree" id="vargoalthree" #vargoalthree="ngModel" [(ngModel)]="varGoalThree.Value" (ngModelChange)="goalThreeChanged()" required>
                <mat-option *ngFor="let goal of goalListThree" value="{{goal}}">{{goal}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100" *ngIf="varGoalThree.Value === 'Other'">
              <mat-label for="vargoalthreeother" aria-labelledby="vargoalthreeother" [ngClass]="{'active' : varGoalThreeOther.Value}">{{ 'copy.label.DEMOGRAPHICS.goalThreeOther' | copy | async }}</mat-label>
              <input matInput name="vargoalthreeother" id="vargoalthreeother" [attr.aria-label]="vargoalthreeother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varGoalThreeOther.Value" #vargoalthreeother="ngModel" required/>
              <mat-error><app-validation  [object]="vargoalthreeother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>

          <div class="w-100" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
            <div class="required">
              <label class="label-display">
                <span [innerHTML]="'copy.label.DEMOGRAPHICS.challenge'|copy|async"></span>
              </label>
              <mat-radio-group class="w-100" [(ngModel)]="varChallenge.Value" name="challengeValue" required>
                <mat-radio-button *ngFor="let challenge of challengeList"value="{{challenge}}">{{challenge}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <mat-form-field class="w-100" *ngIf="varChallenge.Value === 'Other'">
              <mat-label for="challengeother" aria-labelledby="challengeother" [ngClass]="{'active' : varChallengeOther.Value}">{{ 'copy.label.DEMOGRAPHICS.challengeOther' | copy | async }}</mat-label>
              <input matInput name="challengeother" id="challengeother" [attr.aria-label]="challengeother" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varChallengeOther.Value" #challengeother="ngModel" required/>
              <mat-error><app-validation  [object]="challengeother" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>

          <div class="required">
            <label class="w-100" for="smstext">{{'copy.label.ATTENDEE.smstext' | copy | async }} <a matTooltip="{{'copy.label.ATTENDEE.smstexttooltip'|copy|async}}">
              <i tabindex="0" class="fa fa-info-circle" aria-hidden="true"></i>
            </a></label>
            
            <mat-radio-group class="w-100" [(ngModel)]="SMStext.Value" required #smstext="ngModel" name="smstext">
              <mat-radio-button [value]="'Yes'">Yes</mat-radio-button>
              <mat-radio-button [value]="'No'">No</mat-radio-button>
              <div class="w-100">
                <app-validation  [object]="smstext" isRequired=true></app-validation>
              </div>
            </mat-radio-group>
          </div>
          <div *ngIf="SMStext.Value === 'Yes'">
            <label class="w-100" for="smsprovider">{{'copy.label.ATTENDEE.smsprovider' | copy | async }}</label>
            <mat-form-field class="w-40">
              <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
              <mat-select disableRipple name="smsprovider" id="smsprovider" #stock="ngModel" [(ngModel)]="SMSprovider.Value" required>
                <mat-option *ngFor="let ss of providervalues" value="{{ss}}">{{ss}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="SMStext.Value === 'Yes' && SMSprovider.Value === 'Other'">
            <mat-form-field class="w-100">
              <mat-label for="smsproviderother" aria-labelledby="smsproviderother" [ngClass]="{'active' : smsproviderother}">{{ 'copy.label.ATTENDEE.smsproviderother' | copy | async }}</mat-label>
              <input matInput name="smsproviderother" id="smsproviderother" [attr.aria-label]="smsproviderother" type="text" maxlength="50" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="SMSproviderother.Value" #smsproviderother="ngModel" required/>
              <app-validation  [object]="smsproviderother" isRequired=true></app-validation>
            </mat-form-field>
          </div>

          <div class="w-100" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor'">
            <div class="w-100">{{'copy.label.ATTENDEE.promotionalemail' | copy | async }}</div>
            <div class="agreeCheckbox">
              <div class="checkboxFlexContainer">
                <mat-checkbox name="promotionalemail" [ngModel]="attendee.$mtcOptOut" (change)="attendee.$mtcOptOut = !attendee.$mtcOptOut" aria-labelledby="promotionalemail_label"></mat-checkbox>
                <label id="promotionalemail_label">{{'copy.label.ATTENDEE.optOut' | copy | async }}</label>
              </div>
            </div>
          </div>

        </div>
      </article>
    </section>
    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
        <!-- <i class="material-symbols-outlined icon-align">chevron_left</i> -->
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
        <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
      </button>
      <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>

